module.exports = __webpack_public_path__ + "img/Urine Strips.2mid).fa1aab37.jpg";